import axios from 'axios'



let baseURL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3000'
  : 'https://credit.creditscoring.cn/api';


// 创建axios实例
const api = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 添加token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器 - 统一处理错误
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      if (typeof window !== 'undefined') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// 登录接口（改为手机号登录）
export const login = async (phone, code) => {  // 参数改为phone和code
  try {
    const response = await api.post('/login', { phone, code })  // 请求体传递phone和code
    return response.data
  } catch (error) {
    const message = error.response?.data?.message || '登录失败，请检查手机号和验证码'  // 错误提示同步修改
    throw new Error(message)
  }
}

export const sendCode = async (phone) => {
  try {
    const response = await api.post('/send-code', { phone })
    return response.data
  } catch (error) {
    const message = error.response?.data?.message || '发送验证码失败，请重试'
    throw new Error(message)
  }
}

// 注册接口（改为手机号注册）
export const register = async (phone, password) => {  // 参数改为phone
  try {
    const response = await api.post('/register', { phone, password })  // 请求体改为phone
    return response.data
  } catch (error) {
    const message = error.response?.data?.message || '注册失败，手机号可能已被使用'  // 错误提示修改
    throw new Error(message)
  }
}

export default api